export const setNewsletter = () => {
    return {
        type:'SET_NEWSLETTER'
    }
}